/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ApplicationsControllerFindOneQueryResponse, ApplicationsControllerFindOnePathParams, ApplicationsControllerFindOneQueryParams, ApplicationsControllerFindOne400, ApplicationsControllerFindOne401, ApplicationsControllerFindOne403, ApplicationsControllerFindOne404 } from "../../models/checklistsController/ApplicationsControllerFindOne";

function getApplicationsControllerFindOneUrl(id: ApplicationsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/checklist-applications/${id}` as const }  
  return res
}

/**
 * @summary Get a specific checklist application by ID
 * {@link /api/v1/checklist-applications/:id}
 */
export async function applicationsControllerFindOne(id: ApplicationsControllerFindOnePathParams["id"], params?: ApplicationsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ApplicationsControllerFindOneQueryResponse, ResponseErrorConfig<ApplicationsControllerFindOne400 | ApplicationsControllerFindOne401 | ApplicationsControllerFindOne403 | ApplicationsControllerFindOne404>, unknown>({ method : "GET", url : getApplicationsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}